import { toast, ToastOptions } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const defaultOptions: ToastOptions = {
  position: "top-right",
  autoClose: 3000,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  className: "",
  bodyClassName: "text-black text-center text-base p-0 font-[poppins]",
  closeButton: false,
};

type CustomToastProps = {
  title: string;
  message: string;
  imgSrc: string;
};

const CustomToast: React.FC<CustomToastProps> = ({
  title,
  message,
  imgSrc,
}) => {
  return (
    <div className="bg-white text-black z-[100!important] absolute w-full h-full top-0 left-0">
      <div className="w-full h-full p-5">
        <div className="flex w-full gap-x-3 pb-2">
          <img src={imgSrc} alt="Icon" className="w-6 h-6" />
          <p className="font-semibold text-black text-sm 2xl:text-base">
            {title}
          </p>
        </div>
        <div className="text-left">
          <p className="text-black/80 text-sm 2xl:text-base">{message}</p>
        </div>
      </div>
    </div>
  );
};

export const statusToastService = {
  success: (message: string, autoClose = 3000) => {
    toast.success(
      <CustomToast
        title="Looks good"
        message={message}
        imgSrc="/status/checkmark.svg"
      />,
      {
        ...defaultOptions,
        autoClose,
        className: `
          bg-white-600 
        text-black 
        text-center 
        rounded-2xl
        flex 
        items-center 
        shadow-lg
        p-0 
        max-h-[5.5rem!important] 
        min-h-[5.5rem!important] 
        z-[100!important]
        position-[absolute!important]`,
      }
    );
  },
  error: (message: string, autoClose = 3000) => {
    toast.error(
      <CustomToast
        title="Potential issues"
        message={message}
        imgSrc="/status/error.svg"
      />,
      {
        ...defaultOptions,
        autoClose,
        className: `
          bg-white-600 
          text-black 
          text-center 
          rounded-2xl
          flex 
          items-center 
          shadow-lg
          p-0 
          max-h-[5.5rem!important] 
          min-h-[5.5rem!important] 
          z-[100!important]
          position-[absolute!important]`,
      }
    );
  },
  warn: (message: string, autoClose = 3000) => {
    toast.warn(
      <CustomToast
        title="Potential issues"
        message={message}
        imgSrc="/status/warning.svg"
      />,
      {
        ...defaultOptions,
        autoClose,
        className: `
            bg-white-600 
          text-black 
          text-center 
          rounded-2xl
          flex 
          items-center 
          shadow-lg
          p-0 
          max-h-[7rem!important] 
          min-h-[7rem!important] 
          z-[100!important]
          position-[absolute!important]`,
      }
    );
  },
};
